module.exports = __webpack_public_path__ + "static/media/PDF_66.49019e1d.pdf";